<!-- @format -->

<section
	id="reviews-drawer-container"
	class="reviews-drawer-container hmf-flex-s-column">
	<product-reviews-responsive-rating-summary
		[percentage]="percentage"
		[rating]="rating"
		[starsOptions]="starsOptions"
		[count]="count"
		[writeAReviewLabel]="writeAReviewLabel"
		[writeAReviewType]="writeAReviewType"
		[isDrawer]="true">
	</product-reviews-responsive-rating-summary>

	@if (isReviewsAISummaryEnabled()) {
		<product-reviews-ai-summary></product-reviews-ai-summary>
	}

	<!-- Carousel section -->
	<section class="drawer-carousel-section hmf-pl-s">
		<product-reviews-carousel-component
			class="drawer-carousel"
			[selector]="'drawer-carousel'"
			[mediaSource]="mediaSource"></product-reviews-carousel-component>
	</section>
	<!-- AI Generated Pro/Cons section -->
	@if (isHighlyRatedReviewsEnabled()) {
		<section class="hmf-pl-s">
			<product-reviews-ai-pros-cons [isDrawer]="true"></product-reviews-ai-pros-cons>
		</section>
	}
	<!-- Filters section -->
	<product-reviews-filter-drawer
		class="hmf-mt-l hmf-pl-s"
		[hasSearched]="!!searchFilter"
		[reviewCount]="reviewsPaginated?.pagination?.total"
		[reviewsFilters]="reviewsFilters()"
		[reviewsProsCons]="reviewsProsCons()"
		[isHighlyRatedReviewsEnabled]="isHighlyRatedReviewsEnabled()">
	</product-reviews-filter-drawer>

	<!-- Reviews section -->
	<section class="hmf-pl-s hmf-pr-s">
		<product-reviews-review-drawer-list
			[reviewMedia]="reviewsPaginated?.reviews"
			[isLoading]="isLoading"
			[reviewCount]="reviewsPaginated?.pagination?.total"
			[isResultFromSearch]="!!searchFilter"
			[searchFilter]="searchFilter"></product-reviews-review-drawer-list>
	</section>

	@if (reviewsPaginated?.reviews.length) {
		<!-- Load more reviews section -->
		<section>
			<product-reviews-load-more-button
				[label]="loadMoreLabel"
			[displayButton]="
				reviewsPaginated.pagination.currentPage !== reviewsPaginated.pagination.lastPage
			"
			[disabled]="
				reviewsPaginated.pagination.currentPage ===
					reviewsPaginated.pagination.lastPage || isLoadMoreRequesting
			"
			[total]="reviewsPaginated.pagination.total"
			[remain]="reviewsPaginated.reviews.length"
			(loadMoreClicked)="loadMoreReviews()"></product-reviews-load-more-button>
		</section>
	}
</section>